/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from "react-redux";
import cx from "classnames";
import PropTypes from "prop-types";
import { Outlet } from "react-router";
import axios from "axios";
import Snackbar from "../components/Snackbar/Snackbar";
import * as actions from "../store/actions";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// core components
import Footer from "../components/Footer/Footer.jsx";

import appStyle from "../assets/jss/material-dashboard-pro-react/layouts/adminStyle.jsx";

import Glas from "../components/Loading/Glas";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MainMenu } from "./MainMenu";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

MainMenu.propTypes = { user: PropTypes.any };

var ps;

class Dashboard extends React.Component {
  state = {
    mobileOpen: false,
    fixedClasses: "dropdown",
    loading: true,
  };
  mainPanel = React.createRef();

  componentDidMount() {
    axios.get("core/app/init").then((response) => {
      if (response.data.forceRedirect !== undefined && response.data.forceRedirect) {
        window.location.href = response.data.forceRedirect;
      } else {
        this.props.updateUser({
          ...response.data.data.user,
          isImpersonating: response.headers["is-impersonating"] === "1",
        });
      }
      this.setState({ loading: false });
    });

    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", this.resizeFunction);
  }

  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = this.getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  resizeFunction = () => {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  };

  render() {
    const { classes } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.props.miniActive,
        [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1,
      });

    return (
      <div className={classes.wrapper}>
        <Snackbar
          close
          closeNotification={this.props.closeMessage}
          color={this.props.message.color}
          message={this.props.message.text}
          open={this.props.message.open}
          place={this.props.message.place}
        />
        <ToastContainer
          autoClose={5000}
          closeOnClick
          draggable
          newestOnTop={false}
          pauseOnFocusLoss
          pauseOnHover
          position={"bottom-right"}
          theme={"colored"}
        />
        {this.state.loading ? <Glas /> : null}
        <MainMenu user={this.props.user} />
        <div className={mainPanel} ref={this.mainPanel}>
          <div className={classes.content}>
            <div className={classes.container}>
              <Outlet />
            </div>
          </div>
          <Footer fluid />
        </div>
      </div>
    );
  }
}
Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

//REDUX
const mapStateToProps = (state) => {
  return {
    miniActive: state.app.sidebarMiniActive,
    message: state.message,
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUser: (user) => dispatch({ type: actions.UPDATE_USER, payload: { user: user } }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(Dashboard, appStyle));
